import highPriority from "../assets/images/icon/high-priority.png";
import mediumPriority from "../assets/images/icon/medium-priority.png";
import lowPriority from "../assets/images/icon/low-priority.png";
const priorityIcons = {
  high: highPriority,
  medium: mediumPriority,
  low: lowPriority
};
export {priorityIcons};